import { Card, Control as ControlType } from '@yleisradio/areena-types';
import { useState } from 'react';
import { canPlayFromStart } from 'utils/card';
import { StartoverDialog } from './StartoverDialog';

type Params = {
  card: Card;
  cardViewId: string;
  playControl: ControlType | null | undefined;
};

export function useStartoverDialog({ card, cardViewId, playControl }: Params) {
  const [isOpen, setIsOpen] = useState(false);
  const playFromStart = canPlayFromStart(card);

  const openStartoverDialog = () => setIsOpen(true);

  const startoverDialog =
    playFromStart && playControl ? (
      <StartoverDialog
        title={card.title || ''}
        description={card.description || ''}
        labels={card.labels || []}
        image={card.image}
        cardViewId={cardViewId}
        playControl={playControl}
        cardPointer={card.pointer}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    ) : null;

  return { playFromStart, openStartoverDialog, startoverDialog };
}
